export default function CaseStudiesBlock() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-12 sm:py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Contrasting banner */}
        <div className="relative rounded-2xl overflow-hidden bg-[#1A2B4C]">
          {/* Decorative background accents */}
          <div className="absolute top-0 right-0 w-72 h-72 bg-[#C5A880]/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-56 h-56 bg-[#C5A880]/15 rounded-full blur-2xl translate-y-1/2 -translate-x-1/4 pointer-events-none"></div>

          {/* Top accent strip */}
          <div className="h-1 w-full bg-gradient-to-r from-[#C5A880] via-[#E8D5B7] to-[#C5A880]"></div>

          <div className="relative z-10 px-8 sm:px-16 py-12 sm:py-16 flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
            {/* Left: icon + text */}
            <div className="flex flex-col sm:flex-row items-center md:items-start gap-6 sm:gap-8 text-center md:text-left">
              <div className="flex-shrink-0 flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-[#C5A880] rounded-2xl">
                <i className="ri-folder-open-line text-3xl sm:text-4xl text-white"></i>
              </div>
              <div>
                {/* Label badge */}
                <span className="inline-block bg-[#C5A880]/25 text-[#E8D5B7] text-xs sm:text-sm font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest mb-3 font-['Montserrat']">
                  Портфолио
                </span>
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 font-['Playfair_Display'] leading-tight">
                  Результаты нашей работы
                </h2>
                <p className="text-sm sm:text-base text-[#B0BCCC] max-w-xl leading-relaxed font-['Montserrat']">
                  Посмотрите реальные примеры наших работ и убедитесь в качестве решений, которые мы создаем для бизнеса.
                </p>
              </div>
            </div>

            {/* Right: CTA button */}
            <div className="flex-shrink-0">
              <a
                href="/case"
                onClick={handleScrollToTop}
                className="inline-flex items-center gap-2 sm:gap-3 bg-[#C5A880] hover:bg-[#D4B990] text-white px-7 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat']"
              >
                <i className="ri-eye-line text-lg sm:text-xl"></i>
                Посмотреть все кейсы
                <i className="ri-arrow-right-line text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Bottom accent strip */}
          <div className="h-1 w-full bg-gradient-to-r from-[#C5A880] via-[#E8D5B7] to-[#C5A880]"></div>
        </div>
      </div>
    </section>
  );
}
